import { Button } from "@/components/ui/button"
import type { FlashcardActivity } from "@/services/api/odin/activities/flashcards/study-session/update"

interface FlashcardFeedbackFooterProps {
  activity: FlashcardActivity
  onRetry: () => void
  onContinueStudying: () => void
  isPending: boolean
}

export default function FlashcardFeedbackFooter({
  activity,
  onRetry,
  onContinueStudying,
  isPending,
}: FlashcardFeedbackFooterProps) {
  const isApproved = activity.feedback.scorePercentage >= activity.feedback.approvalScore

  return (
    <footer className="w-full max-w-3xl px-2 pb-4">
      <div className="mx-auto flex flex-col items-center gap-3">
        {isApproved ? (
          <Button size="lg" className="w-full" onClick={onContinueStudying}>
            Continuar estudiando
          </Button>
        ) : (
          <>
            <Button size="lg" className="w-full" onClick={onRetry} disabled={isPending}>
              Reintentar
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="w-full"
              onClick={onContinueStudying}
              disabled={isPending}
            >
              Continuar estudiando
            </Button>
          </>
        )}
      </div>
    </footer>
  )
}
